import logo from './logo.svg';
import './App.css';
import { BannersSection } from "./components";

function App() {
    const bannerDetail = () => "http://www.google.com";
    const banners = [
        {
            id: 123,
            img: "https://dummyimage.com/100x100/000/fff&text=100x100",
            url: bannerDetail(),
        },
        {
            id: 234,
            img: "https://dummyimage.com/300x300/000/fff&text=300x300",
            url: bannerDetail(),
        },
        {
            id: 345,
            img: "https://dummyimage.com/500x500/000/fff&text=500x500",
            url: bannerDetail(),
        },
    ];
    return (
        <div className="App">
            <header className="App-header">
                <img src={logo} className="App-logo" alt="logo" />
                <p>
                    Edit <code>src/App.js</code> and save to reload.
                </p>
                <a
                    className="App-link"
                    href="https://reactjs.org"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Learn React
                </a>
                <BannersSection banners={banners} />
            </header>
        </div>
    );
}

export default App;
